// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container-search{background-color:#fafcff}.container-search .row-search{min-height:70vh;flex-wrap:nowrap}.container-search .row-search .dashboard-search{flex:1;overflow:auto;min-width:0;padding:1.5em 1.5em}\n", ""]);
// Exports
module.exports = exports;
